import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import LoadingSpinner from "../../components/Loading";
import { InputBox } from "../../components/CustomWidgets/InputBox";
import deleteicon from "../../assets/Order/Delete.svg";
import { toast } from "react-toastify";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import AddPackage from "../../assets/Inventory/AddPackage.svg";

const ProductPackages = ({
    onClose,
  productId,
  savedPackages,
  onSavePackages,
}) => {
  const { t } = useTranslation();
  const [packagesArray, setPackagesArray] = useState([]);
  const [originalPackages, setOriginalPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );

  useEffect(() => {
    if (!productId) return;
      GetAllPackages(productId);
  }, [productId]);

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 50,
    },
    container: {
      width: "50%",
      maxHeight: "80vh", // ✅ limit modal height
      overflow: "hidden", // prevent full overflow
      padding: "15px",
      borderRadius: "18px",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 60,
      display: "flex",
      flexDirection: "column",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 5,
    },
    title: {
      fontSize: "20px",
      fontWeight: "bold",
      textAlign: "center",
      marginBottom: "10px",
    },
    cancelIcon: {
      cursor: "pointer",
    },
  };

  const handleAddPackage = () => {
    setPackagesArray((prev) => [
      ...prev,
      { pack_price: "", pack_qty: "", secondary_barcode: "" },
    ]);
  };

  const handleDeletePackage = (index) => {
    const updated = packagesArray.filter((_, i) => i !== index);
    // if (updated.length === 0) {
    //   onClose();
    // } else {
    setPackagesArray(updated);
    // }
  };

  const handleChange = (index, field, value) => {
    const updated = [...packagesArray];
    updated[index][field] = value;
    setPackagesArray(updated);
  };

  const handleSave = () => {
    // Step 1: Check for incomplete packages
    const hasIncomplete = packagesArray.some(
      (pkg) => !pkg.pack_price || !pkg.pack_qty || !pkg.secondary_barcode
    );

    if (hasIncomplete) {
      toast.error(t("Each pack must include quantity, price, and barcode."));
      return;
    }

    // Step 2: Check for duplicate pack_qty
    const qtySet = new Set();
    let hasDuplicateQty = false;

    for (const pkg of packagesArray) {
      const qty = String(pkg.pack_qty).trim();
      if (qtySet.has(qty)) {
        hasDuplicateQty = true;
        break;
      }
      qtySet.add(qty);
    }

    if (hasDuplicateQty) {
      toast.error(t("Two packages cannot have the same pack quantity."));
      return;
    }

    // Step 3: Check for duplicate secondary_barcode
    const barcodeSet = new Set();
    let hasDuplicateBarcode = false;

    for (const pkg of packagesArray) {
      const barcode = String(pkg.secondary_barcode).trim().toLowerCase();
      if (barcodeSet.has(barcode)) {
        hasDuplicateBarcode = true;
        break;
      }
      barcodeSet.add(barcode);
    }

    if (hasDuplicateBarcode) {
      toast.error(t("Two packages cannot have the same barcode."));
      return;
    }

    // Step 4: Check if changes were made
    const hasChanged = JSON.stringify(packagesArray) !== originalPackages;

    if (hasChanged) {
      onSavePackages(productId, packagesArray); // Save to parent local
    }

  };

  const GetAllPackages = async (prodId) => {
    setLoading(true);
    try {
      let payload = {
        product_id: prodId,
        user_id: user_id,
        company_id: company_id,
      };
      const response = await axiosInstance.post(
        URLS.GET_PRODUCT_PACKAGE,
        payload
      );
      // console.log("GetAllPackages===>", response?.data);
      if (response?.data?.result[0]?.status_code == 200) {
        //   ShowAddPackagesContainer(true);
    setLoading(false);
        setPackagesArray(response?.data?.result[0]?.response);
        setOriginalPackages(
          JSON.stringify(response?.data?.result[0]?.response)
        );
      } else {
        // setPackagesArray([])
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }finally{
    setLoading(false);

    }
  };
    const isChanged = originalPackages?.length < 1 ? false : JSON.stringify(packagesArray) !== originalPackages;


  return (
  <>
    {loading && <LoadingSpinner />}
    <div className="bg-white w-full rounded-xl shadow p-5">
      <div className="bg-[#F5F5F5] rounded-lg p-5 overflow-y-auto" style={{ maxHeight: "60vh" }}>
        <div className={`flex items-center mb-3  ${(originalPackages?.length < 1 && packagesArray.length < 1) ? "justify-start" : "justify-between"}`}>
          <span className="font-medium">{(originalPackages?.length < 1 && packagesArray.length < 1) ? t('No pack added yet — Click to add') :t("Package Details")}</span>
          <div
            onClick={handleAddPackage}
            className="flex rounded-md py-2 px-3 mx-3 bg-[#7EC242] text-white font-normal text-sm cursor-pointer"
          >
               <img
                                      className="me-2 w-4 h-4"
                                      src={AddPackage}
                                      alt="add"
                                      // onClick={() => handleDeletePackage(index)}
                                    />
            {(originalPackages?.length < 1 && packagesArray.length < 1) ? t('Add Pack') :t("Add New Pack")}
          </div>
        </div>

        {packagesArray.map((pack, index) => (
          <div
            key={index}
            className="flex flex-row gap-5 mt-1 mb-5 items-start"
          >
            {/* Sale Price */}
            <span className="w-[30%]">
              <InputBox
              backgroundColor={"#fff"}
                label={t("Sale Price")}
                placeholder={t("Enter Sale Price")}
                value={pack.pack_price}
                onChange={(e) => {
                  const val = e.target.value;
                  const regex = /^\d{0,7}(\.\d{0,2})?$/;
                  if (regex.test(val) || val === "") {
                    handleChange(index, "pack_price", val);
                  }
                }}
              />
            </span>

            {/* Pack Quantity */}
            <span className="w-[30%]">
              <InputBox
                backgroundColor={"#fff"}
                label={t("Pack Quantity")}
                placeholder={t("Enter Pack Quantity")}
                value={pack.pack_qty}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d{0,3}$/.test(val) || val === "") {
                    handleChange(index, "pack_qty", val);
                  }
                }}
              />
            </span>

            {/* Barcode */}
            <span className="w-[30%]">
              <InputBox
              backgroundColor={"#fff"}
                label={t("Barcode")}
                placeholder={t("Enter Barcode")}
                value={pack.secondary_barcode}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d{0,18}$/.test(val)) {
                    handleChange(index, "secondary_barcode", val);
                  }
                }}
              />
            </span>

            <img
              className="mx-1 mt-14 cursor-pointer w-5 h-5"
              src={deleteicon}
              alt="deleteicon"
              onClick={() => handleDeletePackage(index)}
            />
          </div>
        ))}
        <div className={`flex  items-center ${isChanged && packagesArray?.length < 1 ? 'justify-between' : 'justify-end'}`}>
 {isChanged && packagesArray?.length < 1 &&
        <p className="text-[#EB5563]">
        {t('Click ‘Save’ to confirm pack deletion')}
        </p>
        } 
        {(packagesArray?.length > 0 || isChanged) && (
          <div className="flex justify-end mt-4 gap-3">
              <button
              onClick={handleSave}
            className={`px-4 py-2 bg-[#78CFEC] text-white rounded-md text-sm transition-opacity ${
        (packagesArray?.length > 0 || isChanged) ? "opacity-100 cursor-pointer" : "opacity-50 cursor-not-allowed"
      }`}
      disabled={!(packagesArray?.length > 0 || isChanged)}
            >
              {t("Save")}
            </button>
            <button
              onClick={()=>{onClose();
                setPackagesArray([]);
                setOriginalPackages([])
              }}
              className="px-4 py-2 bg-gray-300 rounded-md text-sm"
            >
              {t("Cancel")}
            </button>
          
          </div>
        )}
        </div>
       
      </div>
    </div>
  </>
);
};

export default ProductPackages;
